import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Radio, RadioGroup, Button, Icon } from '@components';
import doczSet from '@root/doczrc.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "nes-design"
    }}>{`NES-design`}</h1>
    <h2 {...{
      "id": "game-style-react-ui-component-library"
    }}>{`Game Style React UI Component Library`}</h2>
    <div style={{
      height: 150,
      display: 'flex',
      alignItems: 'center',
      width: 350,
      justifyContent: 'center'
    }}>
  <RadioGroup mdxType="RadioGroup">
    <Radio defaultChecked autoFocus value="start" children={<Icon customClass="snes-logo" mdxType="Icon" />} mdxType="Radio" />
    <Radio value="github" children={<Icon customClass="snes-jp-logo" mdxType="Icon" />} mdxType="Radio" />
  </RadioGroup>
    </div>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      fontSize: 20
    }}>
  <Button type="text" onClick={() => window.open(`${doczSet.base}install`, '_self')} mdxType="Button">Getting Started</Button>
  <Button type="text" onClick={() => window.open('https://github.com/loo41/NES-design')} style={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: 50
      }} mdxType="Button">
    Github <Icon name="github" mdxType="Icon" />
  </Button>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      